import { getApiVersion, http } from '../utils/domain'
import { stringifyQuery } from '../utils/query'

// 获取一个共享链接的详细信息
export const fetchSharedLinkInfo = (sharedId) => {
  return http()
    .get(
      `${getApiVersion()}/sharedLink/fetchSharedLinkInfo${stringifyQuery({
        sharedId,
      })}`
    )
    .json()
}

// 创建共享链接
export const createSharedLink = (params) => {
  return http()
    .post(`${getApiVersion()}/sharedLink/createSharedLink`, params)
    .json()
}

// 将url转换为二维码
export const getQrCodeUrl = (url) => {
  return `${getApiVersion()}/shortLink/getQrCode${stringifyQuery({
    url: encodeURIComponent(url),
  })}`
}
